import qs from 'qs';
import { AxiosInstance } from 'axios';
import { CollectionResource } from '@app/data/resources';
import {
    AllocateVirtualLicenceInput,
    VirtualLicenceCurrentListFilterInput,
    VirtualLicenceQuotaAttachmentInput,
    VirtualLicenceTaskCategoryAttachmentInput,
    VirtualLicenceTaskCategoryGroupAttachmentInput,
} from './inputs';
import { VirtualLicenceResource } from './resources';
import { VirtualLicenceRef } from './refs';

export default class VirtualLicence {
    private basePath = '/api/virtual-licence';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Allocate new virtual licence
    allocate = async (input: AllocateVirtualLicenceInput): Promise<VirtualLicenceRef> => {
        const { data } = await this.http.post(`${this.basePath}/`, input);
        return data;
    };

    // Fetch currently non-ended list of virtual licences
    getCurrentList = async (
        filter: VirtualLicenceCurrentListFilterInput,
    ): Promise<CollectionResource<VirtualLicenceResource, {}>> => {
        const query = qs.stringify({ ...filter });
        const { data } = await this.http.get(`${this.basePath}/current?${query}`);
        return data;
    };

    // Get single virtual licence
    getById = async (id: ID): Promise<VirtualLicenceResource> => {
        const { data } = await this.http.get(`${this.basePath}/${id}`);
        return data;
    };

    // Manually end virtual licence
    end = async (id: ID): Promise<VirtualLicenceRef> => {
        const { data } = await this.http.delete(`${this.basePath}/${id}`);
        return data;
    };

    // Suspend virtual licence
    suspend = async (id: ID): Promise<VirtualLicenceRef> => {
        const { data } = await this.http.put(`${this.basePath}/${id}/suspend`);
        return data;
    };

    // Resume suspended virtual licence
    resume = async (id: ID): Promise<VirtualLicenceRef> => {
        const { data } = await this.http.delete(`${this.basePath}/${id}/suspend`);
        return data;
    };

    // Set assigned task category groups
    setTaskCategoryGroupAttachmentList = async (
        id: ID,
        input: VirtualLicenceTaskCategoryGroupAttachmentInput[],
    ): Promise<VirtualLicenceRef> => {
        const { data } = await this.http.put(`${this.basePath}/${id}/task-category-group`, {
            task_category_groups: input,
        });

        return data;
    };

    // Sets task category attachment list
    setTaskCategoryAttachmentList = async (
        id: ID,
        input: VirtualLicenceTaskCategoryAttachmentInput[],
    ): Promise<VirtualLicenceRef> => {
        const { data } = await this.http.put(`${this.basePath}/${id}/task-category`, {
            task_categories: input,
        });

        return data;
    };

    // Sets quota attachment list
    setQuotaAttachmentList = async (
        id: ID,
        input: VirtualLicenceQuotaAttachmentInput[],
    ): Promise<VirtualLicenceRef> => {
        const { data } = await this.http.put(`${this.basePath}/${id}/quota`, {
            quotas: input,
        });

        return data;
    };

}
